import {getCurrentYear} from '../../utils/commons'
import TopTechProductReviewsLogo from './logo'
import {topTechProductReviewsStylesCA, topTechProductReviewsStylesUK} from './styles'

const baseConfig = {
  domainName: 'toptechproductreviews' as const,
  siteName: 'Top Tech Product Reviews',
  favicon: '/favicons/toptechproductreviews.png',
}

const localeConfigs = {
  uk: {
    measurementId: 'G-MJEB3MF7MC',
    domainType: 'eu' as const,
    camelCaseUrl: 'TopTechProductReviews.co.uk',
    logo: <TopTechProductReviewsLogo className="size-10 shrink-0 tablet:size-8" locale="uk" />,
    title: (category: string, _count: string) =>
      `Top Reviewed ${category} ${getCurrentYear()} in the UK | TopTechProductReviews.co.uk – Best Picks`,
    description: (_category?: string, _count?: string) =>
      `At TopTechProductReviews.co.uk, we curated the best ranked tech devices for ${getCurrentYear()}. Benefit from our expert reviews and detailed product insights to make smart tech choices`,
    styles: topTechProductReviewsStylesUK,
  },
  ca: {
    measurementId: 'G-5C9L15CDEV',
    domainType: 'picks' as const,
    camelCaseUrl: 'TopTechProductReviews.ca',
    logo: <TopTechProductReviewsLogo className="size-10 shrink-0 tablet:size-8" locale="ca" />,
    title: (category: string, _count: string) =>
      `Top Reviewed ${category} ${getCurrentYear()} in CA | TopTechProductReviews.ca – Best Picks`,
    description: (_category?: string, _count?: string) =>
      `At TopTechProductReviews.ca, we curated the best ranked tech devices for ${getCurrentYear()}. Benefit from our expert reviews and detailed product insights to make smart tech choices.`,
    styles: topTechProductReviewsStylesCA,
  },
}

export const createConfig = (locale: string = 'uk') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.uk
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
